import React, { useEffect, useState } from 'react'

// Tools
import { connect, useDispatch } from 'react-redux'
import { useScreenSize } from '@navent-jobs/ui-kit/hooks/screen-size'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// Components
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import { PopOverComponent } from '@navent-jobs/ui-kit/components/pop-over'
import { ButtonCustom, ButtonTitle } from './mixins'
import popOverImgBum from '../../../../assets/images/page-listado-avisos/megafono.svg'
import popOverImgZona from '../../../../assets/images/page-listado-avisos/megafono-zj.svg'

// Tracking
import { DataLayer } from '../../../../constants/gtm-events-alertasv2'

// Redux
import { showModal } from '../../../../redux/actions/modal'
import { getTotalAvisos } from '../../../../redux/actions/home-page'
import { HomePageState } from '../../../../redux/types/home-page'
import { IS_ZONA_JOBS } from '../../../../constants'

interface CreateAlertButtonProps {
  showAlertButton?: boolean
  isUserLoggedIn?: boolean
  totalAvisos: HomePageState['totalAvisos']
  totalSearchResults?: number
  filtersApplied: any[] | null
}

interface CreateAlertActionProps {
  isUserLoggedIn?: boolean
  restrictAlertEnable: boolean
  setpopOverVisible: (value) => void
  showCreateAlertModal: () => void
  redirectToLogin: () => void
}

type PopPositionTypes = 'lowerLeft' | 'rightTop' | 'lowerCenter'

const createAlert = ({
  isUserLoggedIn,
  restrictAlertEnable,
  setpopOverVisible,
  showCreateAlertModal,
  redirectToLogin,
}: CreateAlertActionProps) => {
  DataLayer.handlerAlertIntentionTraking()
  if (isUserLoggedIn) {
    if (restrictAlertEnable) {
      setpopOverVisible(true)
      DataLayer.handlerPopoverAlertTraking()
    } else {
      showCreateAlertModal()
    }
  } else {
    redirectToLogin()
  }
}

const CreateAlertButton = ({
  isUserLoggedIn,
  totalAvisos,
  totalSearchResults,
  filtersApplied,
}: CreateAlertButtonProps) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()

  // set popover position
  const { isMobile, isTabletPortrait, isDesktop, isTabletLandscape } = useScreenSize()
  const [popoverPosition, setPopoverPosition] = useState<PopPositionTypes>('rightTop')
  const handlepopPosition = () => {
    if (isMobile) {
      setPopoverPosition('lowerLeft')
    }
    if (isTabletPortrait) {
      setPopoverPosition('lowerCenter')
    }
    if (isDesktop || isTabletLandscape) {
      setPopoverPosition('rightTop')
    }
  }

  useEffect(() => {
    handlepopPosition()
  }, [])

  // State
  const [restrictAlertEnable, setRestrictAlertEnable] = useState(true)

  // Effect - Valida las restricciones
  useEffect(() => {
    if (filtersApplied && totalAvisos.value !== null && totalSearchResults) {
      const hasFechaPublicacion = filtersApplied.some(f => f.type === 'dias_fecha_publicacion')
      const filterSize = filtersApplied.length - (hasFechaPublicacion ? 1 : 0)
      const ratio = totalSearchResults / totalAvisos.value
      const ratioLimit = hasFechaPublicacion ? 0.015 : 0.05
      setRestrictAlertEnable(ratio > ratioLimit || filterSize === 0)
    } else {
      setRestrictAlertEnable(true)
    }
  }, [filtersApplied, totalAvisos, totalSearchResults])

  // popover control
  const [popOverVisible, setpopOverVisible] = useState(false)
  const handleClosePopOver = () => {
    setpopOverVisible(false)
  }

  // Apagamos el popover cada vez que se actualiza cantidad de resultado de busqueda
  useEffect(() => {
    setpopOverVisible(false)
  }, [totalSearchResults])

  useEffect(() => {
    if (totalAvisos.value === null) {
      dispatch(getTotalAvisos())
    }
  }, [])

  const showCreateAlertModal = () => {
    dispatch(showModal('modal-crear-alerta'))
  }

  const redirectToLogin = () => {
    history.push(`/login?returnTo=${window.location.pathname}`)
  }

  return (
    <PopOverComponent
      visible={popOverVisible}
      onClose={handleClosePopOver}
      content={t('alertas.popOverMessage')}
      imgSrc={IS_ZONA_JOBS ? popOverImgZona : popOverImgBum}
      arrowProps={popoverPosition}
      id="warning-alertas"
      fullwidth
    >
      <ButtonCustom
        disabled={totalSearchResults === 0 || totalAvisos.value === null || (IS_ZONA_JOBS && !filtersApplied)}
        onClick={() =>
          createAlert({ isUserLoggedIn, restrictAlertEnable, setpopOverVisible, showCreateAlertModal, redirectToLogin })
        }
        buttonoptions={{
          size: 'small',
          variant: 'primary',
          type: 'outline',
          block: true,
        }}
      >
        <Icon name="icon-light-megaphone" size="20" />

        <ButtonTitle>{t('alertas.createButtonTitle')}</ButtonTitle>
      </ButtonCustom>
    </PopOverComponent>
  )
}

const states = ({ applicantStore, listadoAvisosStore, homePageStore, filtersStore }) => ({
  isUserLoggedIn: !!applicantStore?.applicant,
  totalAvisos: homePageStore.totalAvisos,
  totalSearchResults: listadoAvisosStore.totalAvisos,
  filtersApplied: filtersStore.filtersApplied,
})

export default connect(states)(CreateAlertButton)
